/**
 * Setters owned by the GL Account sub-controller. Every method goes
 * through the controller's own `setState(partial)` (which mutates
 * internal state and forces a re-render on the host page). Mixed in via
 * `extends GLAccountDelegate`.
 */
class GLAccountDelegate {
    setAccount(accountData) {
        this.setState({ accountData, accountLoaded: true });
    }

    setFunding(fundingData) {
        this.setState({ fundingData, fundingLoaded: true });
    }

    setKpis(kpis) {
        this.setState({ kpis, kpisLoaded: true });
    }

    setCashflow(cashflowData) {
        this.setState({ cashflowData, cashflowLoaded: true });
    }

    setCashflowGrouping(cashflowGrouping) {
        this.setState({ cashflowGrouping });
    }

    setAging(aging) {
        this.setState({ aging, agingLoaded: true });
    }

    setAllLoading() {
        this.setState({
            accountLoaded: false,
            fundingLoaded: false,
            kpisLoaded: false,
            cashflowLoaded: false,
            agingLoaded: false,
        });
    }
}

export default GLAccountDelegate;
